var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0266 0.816984C14.3934 0.0737379 15.4533 0.0737401 15.8201 0.816986L19.393 8.05642C19.5386 8.35157 19.8202 8.55614 20.1459 8.60346L28.1351 9.76436C28.9553 9.88355 29.2828 10.8915 28.6893 11.4701L22.9083 17.1052C22.6726 17.3349 22.565 17.6659 22.6207 17.9903L23.9854 25.9472C24.1255 26.7641 23.2681 27.3871 22.5344 27.0014L15.3887 23.2446C15.0974 23.0915 14.7493 23.0915 14.458 23.2446L7.31225 27.0014C6.57862 27.3871 5.72119 26.7641 5.8613 25.9472L7.22602 17.9903C7.28165 17.6659 7.17411 17.3349 6.93842 17.1052L1.15738 11.4701C0.563866 10.8915 0.891378 9.88355 1.7116 9.76436L9.70079 8.60346C10.0265 8.55614 10.3081 8.35157 10.4537 8.05642L14.0266 0.816984Z",
    fill: "url(#paint0_linear_1874_39703)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1874_39703",
    x1: 14.9233,
    y1: -1,
    x2: 14.9233,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/emptyStar.0d59d3ee8b421b8477a953dc365f24b0.svg";
export { ForwardRef as ReactComponent };